export default __webpack_public_path__ + "static/media/18.c769bad6.png";